import { useAPIQuery } from "@dev2_techwalnut/tw-api-query-hook";
import { Table } from "@dev2_techwalnut/tw-react-crud-dashlite";
import { useMemo, useState } from "react";
import moment from "moment";
import secureLocalStorage from "react-secure-storage";
import FilterModal from "../Machine/dashboard/modals/FilterModal";

const PowerConsumptionDashbarod = () => {
    const privileges = secureLocalStorage.getItem("privileges");
    const [date, setDate] = useState(null);
    const [department, setDepartment] = useState("");
    const { useFetch } = useAPIQuery({
        key: "api/dashboard/energy-production",
        endpoint: "/api/dashboard/energy-production/",
    });
    const { data, isFetching } = useFetch({
        params: {
            date: date ?? moment().format("YYYY-MM-DD"),
            department: department ?? "",
        },
        abortOnNewRequest: true,
        refetchOnWindowFocus: false,
        staleTime: 300000,
        retry: 3,
        keepPlaceholder: true,
        refetchOnReconnect: true,
    });

    const modifiedData = useMemo(() => {
        if (data?.results?.data) {
            return data?.results?.data?.map((d) => ({
                ...d,
            }));
        }
        return [];
    }, [data]);

    const columns = [
        {
            accessor: "machine_name",
            header: "Machine Name",
            sortable: true,
            columnWidth: 150,
            filterable: true,
        },
        {
            accessor: "energy_morning",
            header: "Energy Consumption – Morning (Elorca)",
            sortable: true,
            columnWidth: 150,
        },
        {
            accessor: "production_morning_factory",
            header: "Production – Morning (Factory)",
            sortable: true,
            columnWidth: 150,
        },
        {
            accessor: "production_morning_node",
            header: "Production – Morning (Node)",
            sortable: true,
            columnWidth: 150,
        },
        {
            accessor: "difference_morning",
            header: "Difference - Morning",
            sortable: true,
            columnWidth: 150,
        },
        {
            accessor: "energy_night",
            header: "Energy Consumption – Night (Elorca)",
            sortable: true,
            columnWidth: 150,
        },
        {
            accessor: "production_night_factory",
            header: "Production – Night (Factory)",
            sortable: true,
            columnWidth: 150,
        },
        {
            accessor: "production_night_node",
            header: "Production – Night (Node)",
            sortable: true,
            columnWidth: 150,
        },
        {
            accessor: "difference_night",
            header: "Difference - Night",
            sortable: true,
            columnWidth: 150,
        },
        {
            accessor: "energy_total",
            header: "Energy Consumption – Total",
            sortable: true,
            columnWidth: 150,
        },
        {
            accessor: "production_total_factory",
            header: "Production – Total (Factory)",
            sortable: true,
            columnWidth: 150,
        },
        {
            accessor: "energy_per_production",
            header: "Energy Consumption per Production",
            sortable: true,
            columnWidth: 150,
        },
    ].filter(Boolean);

    return (
        <>
            <div className="nk-block-head nk-block-head-sm">
                <div className="nk-block-between">
                    <div className="nk-block-head-content d-flex">
                        <h3 className="nk-block-title page-title">
                            {`Energy Consumption for ${
                                date ?? moment().format("YYYY-MM-DD")
                            } in ${
                                department !== ""
                                    ? department + " department"
                                    : "All departments"
                            }`}
                            {}
                        </h3>
                    </div>
                    <div className="d-flex align-items-center justify-content-center ms-auto">
                        <button
                            className="btn btn-icon btn btn-outline-primary rounded-pill me-3"
                            data-bs-toggle="modal"
                            data-bs-target="#machine-detials-filter-modal"
                        >
                            <em className="icon ni ni-filter-fill" />
                        </button>
                    </div>
                </div>
            </div>
            <Table
                data={modifiedData ?? []}
                columns={columns}
                isLoading={isFetching}
                manualFilter={false}
                manualSorting={false}
                pagination={false}
                selectRows={false}
                globalSearch={false}
                filterModal={false}
                editRows={false}
                deleteRows={false}
                maxHeight={600}
            />
            <FilterModal setDate={setDate} setDepartment={setDepartment} />
        </>
    );
};

export default PowerConsumptionDashbarod;
